import updateCartCount from './updateCartCount';

const changeLineItemOption = async ({ lineNumber, quantity = 1, sellingPlanId = null }) => {
  const changeResponse = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: lineNumber,
      quantity,
      // eslint-disable-next-line camelcase
      selling_plan: sellingPlanId || null
    })
  });

  if (!changeResponse.ok) {
    const errorText = await changeResponse.text();
    throw new Error(`Failed to update line item selling plan: ${changeResponse.status} ${errorText}`);
  }

  const cart = await changeResponse.json();
  updateCartCount(cart.item_count);
  return cart;
};

export default changeLineItemOption;
